<div class="previous-check-tab">
    <div class="previous-header">
      <span class="previous-date">{{ previousCheck.date | dateCheckFormatter:'fullDate' }}</span>
      <span class="previous-time">{{ previousCheck.date | dateCheckFormatter:'time12Hour' }}</span>
      <span class="previous-user">{{ previousCheck.userName }}</span>
    </div>
    <div class="audits-list" #scrollContainer (scroll)="onScroll($event)">
        <div class="station-audit d-flex justify-content-start" *ngFor="let audit of previousCheck.previousStationAudits">
            <div class="previous-image-container">
                <img class="previous-no-image" *ngIf="!audit.imageData" src="assets/icons/cameraNoImage.svg" />
                <img class="previous-image" *ngIf="audit.imageData" [src]="'data:image/png;base64,' + audit.imageData" />
            </div>
            <div class="info-section">
                <div class="room-container">
                    <span class="room-title">{{ 'CHECK.ROOM_NUMBER' | translate }}</span>
                    <span class="room-num">{{ audit.roomNumber }}</span>
                </div>
                <div class="prev-comments-container">
                    <span class="prev-comments-title">{{ 'CONFIGURE.COMMENTS' | translate }}</span>
                    <span class="prev-comments" [innerHTML]="audit.comment"></span>
                </div>
            </div>
        </div>
    </div>
  </div>